import ApiService from "@/core/services/api.service";
// action types
export const GET_CLIENTS = "getClients";
export const GET_CLIENT = "getClient";
export const CREATE_CLIENT = "createClient";
export const UPDATE_CLIENT = "updateClient";
export const DELETE_CLIENT = "deleteClient";
export const GET_BUSINESS = "getBusiness";
export const GET_DOCUMENTS = "getDocuments";
export const CHANGE_PASSWORD = "changePassword";
export const RESET_CLIENT_PASSWORD = "resetClientPassword";

export const UPDATE_PASSWORD = "updatePassword";
export const GET_RECOVERY = "getRecovery";

// mutation types
export const SET_CLIENT = "setClient";
export const SET_CLIENTS = "setClients";
export const SET_BUSINESS = "setBusiness";
export const SET_DOCUMENTS = "setDocuments";
export const SET_BRANCHS = "setBranchs";

export const SET_ERROR = "setError";

const state = {
  errors: [],
  business: [],
  documents: [],
  branchs: [],
  clients:[],
  client:{empresa:{}}
};

const actions = {
  [GET_CLIENTS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Cliente/v1/clientes`}, '')
        .then(({ data }) => {
          context.commit(SET_CLIENTS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_CLIENT](context, token) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Cliente/v1/cliente/${token}`}, '')
        .then(({ data }) => {
          context.commit(SET_CLIENT, data);
          console.log('retorna cliente' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_RECOVERY](context, token) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Cliente/v1/cliente/${token}/obtenerRecuperacion`}, '')
        .then(({ data }) => {
          console.log('retorna ' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },

  
  [UPDATE_PASSWORD](context, token) {
    return new Promise((resolve, reject) => {
    ApiService.get({action:`/api/OAuth/v1/cliente/${token}/confirmaRecuperarClave`})
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  
  [GET_BUSINESS](context, user) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Cliente/v1/cliente/${user.tokenUsuario}/empresas`}, '')
        .then(({ data }) => {
          console.log('retorna ' + data);
          context.commit(SET_BUSINESS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_DOCUMENTS](context, filter) {
    console.log('filter' + JSON.stringify(filter));
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action:`/api/Cliente/v1/cliente/documentos`}, filter)
        .then(({ data }) => {
          console.log('retorna ' + data);
          context.commit(SET_DOCUMENTS, data.documentos);
          context.commit(SET_BRANCHS, data.sucursales);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [CHANGE_PASSWORD](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.put({action: `/api/Cliente/v1/cliente/${user.token}/cambiarClave`},  user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR,  ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [RESET_CLIENT_PASSWORD](context, token) {
    return new Promise((resolve, reject) => {
    ApiService.get({action:`/api/Cliente/v1/cliente/${token}/resetearClave`})
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [CREATE_CLIENT](context, user) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post({action:`/api/Cliente/v1/cliente/`}, user)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [UPDATE_CLIENT](context, user) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/Cliente/v1/cliente/${user.tokenUsuario}`}, user)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DELETE_CLIENT](context, token) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.delete({action:`/api/Cliente/v1/cliente/${token}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },


};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CLIENT](state, data) {
    state.error = {};
    state.client = data;
  },
  [SET_CLIENTS](state, data) {
    state.error = {};
    state.clients = data;
  },
  [SET_BUSINESS](state, data) {
    state.error = {};
    state.business = data;
  },
  [SET_DOCUMENTS](state, data) {
    state.error = {};
    state.documents = data;
  },
  [SET_BRANCHS](state, data) {
    state.error = {};
    state.branchs = data;
  }
};

export default {
  state,
  actions,
  mutations
};
